<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Toggl" class="d-icon d-icon--toggl" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14.715 13.603c-.283-.264-.694-.382-1.073-.382h-1.695c-.167 0-.315-.126-.315-.283 0-.132.09-.24.209-.273 0 0 .029-.006.061-.016.305.145.645.212.989.212.523 0 1.047-.154 1.432-.514.372-.35.55-.838.55-1.338 0-.501-.174-.99-.55-1.34a1.701 1.701 0 0 0-.363-.26c.36.084.732-.019.99-.462l-.723-.517-.6.838a2.361 2.361 0 0 0-.736-.112c-.523 0-1.047.154-1.432.514-.373.35-.55.838-.55 1.338 0 .501.174.99.55 1.34l.1.086-.071.039a2.047 2.047 0 0 0-.475.378c-.238.254-.476.63-.476 1.134 0 0-.032 1.072 1.198 1.072h.893c.205 0 .414.132.414.337a.366.366 0 0 1-.061.203h1.708c.257-.286.401-.694.389-1.063-.013-.34-.113-.697-.363-.931Zm-2.132-2.925a.44.44 0 0 1 .314-.122c.116 0 .232.035.315.122a.436.436 0 0 1 .122.314.436.436 0 0 1-.122.315.441.441 0 0 1-.315.122.428.428 0 0 1-.314-.122.436.436 0 0 1-.122-.315.44.44 0 0 1 .122-.314Zm6.99 2.925c-.283-.264-.694-.382-1.073-.382l-1.968-.013c-.125 0-.218-.077-.218-.193 0-.096.048-.237.167-.26.234.074.481.11.728.11.524 0 1.047-.155 1.433-.514.372-.35.549-.838.549-1.34 0-.5-.174-.988-.55-1.338a1.704 1.704 0 0 0-.362-.26c.36.083.732-.02.989-.463l-.723-.517-.6.838a2.36 2.36 0 0 0-.736-.112c-.523 0-1.046.154-1.431.514-.373.35-.55.838-.55 1.339 0 .5.174.989.55 1.339.109.102.234.189.362.26a1.983 1.983 0 0 0-.266.24c-.238.254-.475.63-.475 1.134 0 0-.032 1.072 1.197 1.072h.893c.205 0 .414.132.414.337a.366.366 0 0 1-.061.203h1.708c.257-.286.401-.694.389-1.063-.013-.34-.113-.697-.366-.931Zm-2.659-2.925a.441.441 0 0 1 .315-.122c.115 0 .231.035.314.122a.436.436 0 0 1 .122.314.436.436 0 0 1-.122.315.44.44 0 0 1-.314.122.428.428 0 0 1-.315-.122.436.436 0 0 1-.122-.315c0-.115.039-.23.122-.314ZM22 12.379v1.603c-.212.109-.45.138-.594.144-.777-.003-1.169-.276-1.458-.693-.19-.273-.266-.71-.266-1.23V8h1.824v3.91c0 .258.128.514.494.47ZM8.165 14.127c.642 0 1.284-.205 1.756-.687.46-.469.671-1.12.671-1.791 0-.672-.215-1.323-.671-1.792-.472-.479-1.114-.684-1.756-.684-.642 0-1.285.205-1.757.687-.459.469-.67 1.12-.67 1.792 0 .668.214 1.322.67 1.791.472.476 1.115.684 1.757.684Zm-.418-2.906a.58.58 0 0 1 .408-.157c.148 0 .299.048.408.157a.57.57 0 0 1 .157.408.562.562 0 0 1-.157.408.567.567 0 0 1-.408.157.572.572 0 0 1-.408-.157.567.567 0 0 1-.154-.408c0-.154.048-.302.154-.408Zm-5.063-.305H2V9.6c.042.003.08.006.122.006.555 0 1.008-.478 1.008-1.072V8h1.3v1.429h1.018v1.486H4.431v.829c0 .176.035.314.109.408.112.14.237.234.54.234.147 0 .275-.026.368-.061v1.557c-.25.138-.632.244-1.085.244-.787 0-1.108-.273-1.397-.69-.186-.273-.282-.674-.282-1.195v-1.326Z" fill="#F9DE9B"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconToggl',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
